import React, { useState } from "react";
import { FaCirclePlay } from "react-icons/fa6";
import { Helmet } from "react-helmet-async";

const AboutPage = () => {
  const [videoSrc, setVideoSrc] = useState("");

  const handlePlayVideo = () => {
    setVideoSrc("/videos/aboutus.mp4");
  };

  return (
    <div>
      <Helmet>
        <title>À propos de Nous - MOSA Ingénierie</title>
        <meta
          name="description"
          content="Découvrez l’histoire et les valeurs de MOSA Ingénierie."
        />
      </Helmet>
      <div className="bg-[#F2F2F2] h-full flex flex-col lg:flex-row justify-center items-center px-8 lg:px-24 py-20 lg:py-40 shadow-2xl">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row">
          <div className="w-full lg:w-1/2">
            <div className="p-8">
              <h1 className="text-3xl lg:text-6xl font-bold mb-4 tracking-wider text-center">
                <span className="text-[#0A827D]">Découvrer nous en vidéo </span>
              </h1>
              <p className="text-base lg:text-lg text-gray-700 mb-8 text-justify pt-4 tracking-wider">
                Venez en savoir plus sur nous, notre histoire et nos valeurs
                grâce à notre petite vidéo de présentation
              </p>
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <div className="p-4 relative h-60 lg:h-96">
              {videoSrc ? (
                <iframe
                  src={videoSrc}
                  title="decouvrir l'entreprise"
                  className="w-full h-full bg-gray-700 shadow-lg transition duration-500 ease-in-out transform border-8 border-[#007E79]"
                  allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              ) : (
                <div className="relative w-full h-full">
                  <img
                    src="/images/thumbnail-decouvrir.png"
                    alt="Video Thumbnail"
                    className="w-full h-full object-cover rounded-lg shadow-lg"
                  />
                  <button
                    onClick={handlePlayVideo}
                    className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-lg"
                  >
                    <FaCirclePlay className="h-12 w-12  text-[#F2F2F2] shadow-2xl rounded-full" />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white shadow-2xl">
        <div className="flex flex-col lg:flex-row justify-center items-center">
          <div className="flex flex-col justify-center items-center w-full lg:w-1/2 px-8 lg:pl-24 py-20 lg:py-32 pr-2">
            <div className="flex flex-col text-center">
              <h1 className="text-[#0A827D] text-4xl lg:text-5xl font-bold mb-4 lg:mb-8 tracking-wider">
                Notre histoire
              </h1>
            </div>
            <p className="text-base lg:text-lg text-gray-700 text-left px-4 lg:px-40">
              Portés par une envie d’entreprendre et par l’idée de combiner
              leurs compétences, Sara et Mohamed, qui se sont rencontrés sur les
              bancs de l’université, ont fondé MOSA Ingénierie en 2021.
            </p>
            <br></br>
            <p className="text-base lg:text-lg text-gray-700 text-left px-4 lg:px-40">
              Un bureau d’études spécialisé dans l’économie de la construction
              et le suivi de projet, avec l’ambition d’apporter une approche
              renouvelée au métier d’économiste de la construction
            </p>

            <img
              src="/images/book.png"
              alt="book image"
              className="w-26 lg:w-32 h-32 lg:h-38 pt-8"
            />
          </div>

          <div className="block items-center w-full h-full lg:w-1/2 bg-[#EBF5F5] px-8 lg:px-24 py-20 lg:py-40">
            <div className="flex flex-col lg:flex-row">
              <img
                src="/images/sarache.png"
                alt="logo"
                className="w-36 lg:w-52 h-36 lg:h-52 rounded-full shadow-lg mx-auto lg:mx-0"
              />
              <div className="flex flex-col justify-center text-center lg:text-left lg:pl-8 pt-4 lg:pt-0">
                <h1 className="text-xl lg:text-2xl pb-2 lg:pb-4">
                  <b>Sara FEKIH</b>
                </h1>
                <p>Gérante</p>
                <p>Chef de projet</p>
                <p>Economiste de la construction</p>
              </div>
            </div>
            <div className="flex flex-col lg:flex-row pt-16">
              <img
                src="/images/moha.png"
                alt="logo"
                className="w-36 lg:w-52 h-36 lg:h-52 rounded-full shadow-lg mx-auto lg:mx-0"
              />
              <div className="flex flex-col justify-center text-center lg:text-left lg:pl-8 pt-4 lg:pt-0">
                <h1 className="text-xl lg:text-2xl pb-2 lg:pb-4">
                  <b>Mohamed FEKIH</b>
                </h1>
                <p>Gérant</p>
                <p>Chef de projet</p>
                <p>Economiste de la construction</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* section 3 */}
      <div className="bg-white shadow-2xl">
        <div className="flex flex-col lg:flex-row justify-center">
          <div className="lg:block hidden items-center w-full lg:w-1/3 bg-[#EBF5F5] px-8 lg:py-32">
            <div className="flex justify-center">
              <h1 className="text-[#0A827D] text-3xl lg:text-5xl font-bold mb-4 lg:mb-8 tracking-wider ">
                NOS VALEURS
              </h1>
            </div>
            <div className="flex my-6">
              <img
                src="/images/skill1.png"
                alt="logo"
                className="w-24 h-24 m-4 mx-6"
              />
              <div>
                <h2 className="text-xl lg:text-2xl pb-2 lg:pb-4">
                  <b>Technique</b>
                </h2>
                <p>
                  Nos compétences technique nous permettent d’apporter des
                  solutions efficaces et pertinentes sur les aspects économiques
                  et opérationnels de la construction
                </p>
              </div>
            </div>
            <div className="flex my-6">
              <img
                src="/images/skill3.png"
                alt="logo"
                className="w-24 h-24 m-4 mx-6"
              />
              <div>
                <h2 className="text-xl lg:text-2xl pb-2 lg:pb-4">
                  <b>Rigueur</b>
                </h2>
                <p>
                  Chaque analyse, chaque estimation et chaque recommandation est
                  réalisé avec précision et rigeur afin d‘assurer la fiabilité
                  de nos services
                </p>
              </div>
            </div>
            <div className="flex my-6">
              <img
                src="/images/skill2.png"
                alt="logo"
                className="w-24 h-24 m-4 mx-6"
              />
              <div>
                <h2 className="text-xl lg:text-2xl pb-2 lg:pb-4">
                  <b>Dynamique</b>
                </h2>
                <p>
                  Notre dynamisme nous permet d‘anticiper, de nous adapter et de
                  repondre à vos besoins rapidement à chaque étape du projet
                </p>
              </div>
            </div>
            <div className="flex">
              <img
                src="/images/skill4.png"
                alt="logo"
                className="w-24 h-24 m-4 mx-6"
              />
              <div>
                <h2 className="text-xl lg:text-2xl pb-2 lg:pb-4">
                  <b>Communication</b>
                </h2>
                <p>
                  Nous accordons une grande importance à la communication, tant
                  dans nos relations internes qu'externes. L’échange avec nos
                  clients, partenaires et collègues est au cœur de notre culture
                  d'entreprise
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center w-full lg:w-1/2 px-8 lg:pl-24 py-20 lg:py-32 pr-2">
            <div className="flex flex-col text-3xl lg:text-5xl font-bold mb-6 lg:mb-12 tracking-wider text-[#0A827D] w-full text-center">
              <h1 className="w-full">
                <span className="block">NOS DOMAINES</span>
                <span className="block">D’ACTIVITES</span>
              </h1>
            </div>

            <p className="text-base lg:text-lg text-gray-700 py-5 px-6 pt-10">
              Présent de la conception à la livraison, MOSA ingénierie vous
              accompagne tout au long de votre projet pour vous garantir une
              estimation, une optimisation et un contrôle des coûts de
              construction adapté à vos projets et vos budgets.
            </p>
            <p className="text-base lg:text-lg text-gray-700 py-5 px-6">
              Nous proposons également des missions de suivi de chantier (DET et
              OPC) assurant ainsi une gestion fluide de chaque étape de la
              construction, et permettant de respecter la bonne exécution des
              travaux selon les règles de l’art et les délais fixés.
            </p>
            <p className="text-base lg:text-lg text-gray-700 py-5 px-6">
              Cela concerne tous types de bâtiments, qu’ils soient à usage
              résidentiel collectif ou à vocation tertiaire.
            </p>

            <div className="flex justify-evenly items-start w-full pt-8">
              <img
                src="/images/money.png"
                alt="workers"
                className="w-18 lg:w-36 h-24 lg:h-36 pt-8"
              />
              <img
                src="/images/sablier.png"
                alt="workers"
                className="w-18 lg:w-24 h-24 lg:h-36 pt-8"
              />
            </div>
          </div>

          <div className="lg:hidden block py-12 items-center w-full lg:w-1/3 bg-[#EBF5F5] px-8 lg:py-32">
            <div className="flex justify-center">
              <h1 className="text-[#0A827D] text-3xl lg:text-5xl font-bold mb-4 lg:mb-8 tracking-wider ">
                NOS VALEURS
              </h1>
            </div>
            <div className="flex my-6">
              <img
                src="/images/skill1.png"
                alt="logo"
                className="w-24 h-24 m-4 mx-6"
              />
              <div>
                <h2 className="text-xl lg:text-2xl pb-2 lg:pb-4">
                  <b>Technique</b>
                </h2>
                <p>
                  Nos compétences technique nous permettent d’apporter des
                  solutions efficaces et pertinentes sur les aspects économiques
                  et opérationnels de la construction
                </p>
              </div>
            </div>
            <div className="flex my-6">
              <img
                src="/images/skill3.png"
                alt="logo"
                className="w-24 h-24 m-4 mx-6"
              />
              <div>
                <h2 className="text-xl lg:text-2xl pb-2 lg:pb-4">
                  <b>Rigueur</b>
                </h2>
                <p>
                  Chaque analyse, chaque estimation et chaque recommandation est
                  réalisé avec précision et rigeur afin d‘assurer la fiabilité
                  de nos services
                </p>
              </div>
            </div>
            <div className="flex my-6">
              <img
                src="/images/skill2.png"
                alt="logo"
                className="w-24 h-24 m-4 mx-6"
              />
              <div>
                <h2 className="text-xl lg:text-2xl pb-2 lg:pb-4">
                  <b>Dynamique</b>
                </h2>
                <p>
                  Notre dynamisme nous permet d‘anticiper, de nous adapter et de
                  repondre à vos besoins rapidement à chaque étape du projet
                </p>
              </div>
            </div>
            <div className="flex">
              <img
                src="/images/skill4.png"
                alt="logo"
                className="w-24 h-24 m-4 mx-6"
              />
              <div>
                <h2 className="text-xl lg:text-2xl pb-2 lg:pb-4">
                  <b>Communication</b>
                </h2>
                <p>
                  Nous accordons une grande importance à la communication, tant
                  dans nos relations internes qu'externes. L’échange avec nos
                  clients, partenaires et collègues est au cœur de notre culture
                  d'entreprise
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
